<div class="select select-box" *ngIf="loaded">
    <select name="{{ name }}" id="{{ uidSelectUi }}" (change)="changeOption($event)">
        <option *ngFor="let option of options" [disabled]="option.disabled" [selected]="keySelected.value === option.value" [value]="option.value">
            {{ option.key }}
        </option>
    </select>
</div>
